import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PAIN_POINTS } from '../data/content';
export function PainPoints() {
  return <section className="px-5 py-8" data-id="element-167" data-mp="2lm0wphp5dkx7">
      <div className="mx-auto max-w-xl text-center" data-id="element-168" data-mp="2lp54sq5qh0t5">
        <h2 className="font-display text-2xl font-800 uppercase leading-tight text-white" data-id="element-169" data-mp="26xmsb2c31oej">
          If You're Coaching Every Week...
        </h2>
        <p className="mt-2 text-base font-600 text-white/85" data-id="element-170" data-mp="1xxrcgk7l1586">
          You probably know this feeling.
        </p>
      </div>

      <ul className="mx-auto mt-6 max-w-xl space-y-3" data-id="element-171" data-mp="21zuslm574xzs">
        {PAIN_POINTS.map(p => <li key={p} className="flex items-start gap-3 rounded-2xl border border-red-300/35 bg-[#251827]/95 p-4 shadow-lg shadow-black/20" data-id="element-172" data-mp="1o03g5pubvpnw">
            <span className="mt-0.5 shrink-0 text-red-300" data-id="element-173" data-mp="3idl7zp1rn8oq">
              <CheckIcon size={20} strokeWidth={3} data-id="element-174" data-mp="3ie4febtsieoi" />
            </span>
            <span className="text-sm leading-relaxed text-red-100" data-id="element-175" data-mp="3ncxv8awjuhru">{p}</span>
          </li>)}
      </ul>

      <p className="mx-auto mt-6 max-w-xl text-center font-display text-2xl font-800 uppercase text-white" data-id="element-176" data-mp="1yzn5vpjpviiq">
        That's exhausting.
      </p>

      <p className="mx-auto mt-4 max-w-xl rounded-2xl border border-[var(--pb-lime)]/35 bg-[#132033]/95 p-5 text-center font-display text-xl font-800 uppercase leading-tight text-[var(--pb-lime)] shadow-xl shadow-black/20" data-id="element-177" data-mp="1tzra2dl6axe9">
        Pickleball Coach 360 was built to remove all of that.
      </p>
    </section>;
}